export const LogoName = "Inverness";

export const copyrights = "©2024 Inverness Corp. All Rights Reserved.";
